import markGUAsAsNeedingUpdate from "./markGUAsAsNeedingUpdate"

export default function markGUAsAsNeedingUpdateAll(student, record, year) {
  if (!student || !student.assessments) return Promise.reject()
  const updates = Object.keys(student.assessments).map(assessmentId => {
    return markGUAsAsNeedingUpdate(student, assessmentId, year, record)
  })
  return Promise.all(updates)
}
